// Features.jsx
import { useState } from "react";
import { useLanguage } from "./LanguageContext";
import "./Features.css";

const Features = () => {
  const { t, lang } = useLanguage(); // 👈 recupero lingua e traduzioni
  const [showPdf, setShowPdf] = useState(false);

  const handleOpenPdf = () => setShowPdf(true);
  const handleClosePdf = () => setShowPdf(false);

  // altezza header sticky
  const stickyHeaderHeight = 70;

  // funzione scroll dolce
  const scrollToCommentCarousel = () => {
    const el = document.getElementById("CommentCarousel");
    if (el) {
      const top =
        el.getBoundingClientRect().top + window.pageYOffset - stickyHeaderHeight;
      window.scrollTo({ top, behavior: "smooth" });
      window.history.replaceState(null, "", window.location.pathname);
    }
  };

  // PDF per lingua
  const pdfPaths = {
    it: "/documenti/Liberatoria Italia.pdf",
    en: "/documenti/Liberatoria English.pdf",
    no: "/documenti/Liberatoria Norge.pdf",
    // aggiungi altre lingue se servono
  };

  const currentPdf = pdfPaths[lang] || pdfPaths.it;

  const features = [
    {
      title: t("featuresCard1Title"),
      text: (
        <>
          {t("featuresCard1TextPart1")}
          <span
            onClick={handleOpenPdf}
            style={{
              color: "#0d6efd",
              textDecoration: "underline",
              cursor: "pointer",
            }}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter") handleOpenPdf();
            }}
          >
            {t("featuresCard1TextPdf")}
          </span>
          {t("featuresCard1TextPart2")}
        </>
      ),
    },
    {
      title: t("featuresCard2Title"),
      text: t("featuresCard2Text"),
    },
    {
      title: t("featuresCard3Title"),
      text: t("featuresCard3Text"),
    },
    {
      title: t("featuresCard4Title"),
      text: t("featuresCard4Text"),
    },
  ];

  return (
    <section className="features-section py-5 bg-transparent">
      <div className="container">
        <div className="row justify-content-center mb-4">
          <div className="col-auto">
            <h2 className="features-title text-white text-center">
              {t("ctaTitle")}
            </h2>
          </div>
        </div>

        <div className="row text-center g-4 justify-content-center">
          {features.map((feature, index) => (
            <div
              className="col-12 col-xxl-3 col-xl-4 col-md-6 col-sm-12"
              key={index}
            >
              <div className="feature-card p-4 rounded shadow-sm h-100">
                <h3 className="h5 fw-semibold mb-2">{feature.title}</h3>
                <p>{feature.text}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Pulsante che scorre dolcemente */}
        <div className="row justify-content-center text-center mt-5">
          <div className="col-auto d-flex flex-column flex-md-row gap-3">
            <button
              className="flash-btn"
              onClick={scrollToCommentCarousel}
              style={{ cursor: "pointer" }}
            >
              {t("featuresButton")}
            </button>
          </div>
        </div>
      </div>

      {/* Overlay PDF dinamico */}
      {showPdf && (
        <div
          className="features-pdf-overlay position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-dark bg-opacity-75"
          style={{ zIndex: 1050 }}
          onClick={handleClosePdf}
        >
          <div
            className="features-pdf-container bg-white rounded shadow-lg"
            style={{ width: "80%", height: "80%", position: "relative" }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={handleClosePdf}
              className="btn btn-danger position-absolute top-0 end-0 m-2"
            >
              ✕
            </button>
            <iframe
              src={currentPdf} // 👈 PDF dinamico
              title="Anteprima PDF"
              style={{ width: "100%", height: "100%", border: "none" }}
            />
          </div>
        </div>
      )}
    </section>
  );
};

export default Features;
